/* eslint-disable @typescript-eslint/naming-convention */

import JTableCell from '@atoms/JTabelCell';
import { StatusChip } from '@atoms/StatusChip';
import { ConsumptionAction } from '@constants';
import { CreditConsumptionItem } from '@enterprise/models/get-credit-consumption';
import { formatDate } from '@lib/dateUtils';
import { TableRowStyled } from '@styled/table-row.styled';
import { useTranslation } from 'react-i18next';

interface Props {
  row: CreditConsumptionItem;
}

const SpendingTableRow = ({ row }: Props) => {
  const { t } = useTranslation();
  const {
    creditConsumption_id,
    establishment_name,
    fullname,
    creditConsumption_consumption_action,
    creditConsumption_credits_amount_consumed,
    creditConsumption_created_at,
  } = row;

  return (
    <TableRowStyled
      key={creditConsumption_id}
      data-test={`spending-list-row-${creditConsumption_id}`}
    >
      <JTableCell>{establishment_name}</JTableCell>
      <JTableCell>{fullname}</JTableCell>
      <JTableCell>{creditConsumption_credits_amount_consumed}</JTableCell>
      <JTableCell>
        <StatusChip
          label={
            creditConsumption_consumption_action ===
            ConsumptionAction.PLAY_CV_VIDEO
              ? t('PLAY_CV_VIDEO')
              : t('UNLOCK_CONTACT')
          }
          variant={
            creditConsumption_consumption_action ===
            ConsumptionAction.PLAY_CV_VIDEO
              ? 'purple'
              : 'warning'
          }
          attrs={{ size: 'medium' }}
        ></StatusChip>
      </JTableCell>
      <JTableCell>{formatDate(creditConsumption_created_at)}</JTableCell>
    </TableRowStyled>
  );
};

export default SpendingTableRow;
